module.exports = __webpack_public_path__ + "static/media/fr.8bc6719a.svg";